import React from 'react';
import { SearchResultItem } from '../types';

export const formatDate = (iso: string): string => new Date(iso).toLocaleString();

export const clamp = (n: number, min: number, max: number): number => Math.max(min, Math.min(n, max));

export const tokenize = (q: string): string[] => {
  return (q || "").toLowerCase().trim().split(/\s+/).filter(Boolean);
};

export function highlight(text: string, query: string): React.ReactNode {
  if (!query) return text;
  const terms = tokenize(query).filter((t) => t.length > 1);
  if (!terms.length) return text;
  const pattern = new RegExp(`(${terms.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")})`, "ig");
  return (
    <span>
      {text.split(pattern).map((part, i) =>
        pattern.test(part) ? (
          <mark key={i} style={{ backgroundColor: '#fef08a', color: 'black', borderRadius: '0.125rem', padding: '0 0.125rem' }}>{part}</mark>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </span>
  );
}

export function scoreItem(item: SearchResultItem, terms: string[]): number {
  if (!terms.length) return 0.0001;
  const hay = {
    title: (item.title || "").toLowerCase(),
    crumb: (item.breadcrumb || "").toLowerCase(),
    snip: (item.snippet || "").toLowerCase(),
  };
  let s = 0;
  for (const t of terms) {
    if (hay.title.includes(t)) s += 10;
    if (hay.crumb.includes(t)) s += 3;
    if (hay.snip.includes(t)) s += 1;
  }
  const days = (Date.now() - new Date(item.updatedAt).getTime()) / 86400000;
  s += clamp(1 - days / 90, 0, 1) * 2; // light recency boost
  return s;
}
